/* eslint-disable react/jsx-pascal-case */
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import DropdownButton from "react-bootstrap/DropdownButton";

import Dropdown from "react-bootstrap/Dropdown";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { Box, Grid } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
import Picking_Breadcrumbs from "./Picking_BreadCrumbs";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import moment from "moment";
import { PickingHead_Status_Set } from "./SlicePickingHead";
import "./Picking.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CmpTypographyField } from "./../../Component/Common/ToolBox/ToolBox";
import { CmpInputField } from "./../../Component/Common/ToolBox/ToolBox";
import { CmpStatus } from "./../../Component/Common/ToolBox/ToolBox";
import {
  picking_PickingGetrow_API,
  picking_PickingApprove_API,
} from "./../../Server/ApiV2";
import GCWebReport from "./../../Component/Common/ReuseableComponent/GCWebReport";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { CmpTextFieldV1 } from "../../Component/Common/ToolBox/ToolBoxV1";
export default function PickingDetail() {
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const BarcodeFocusOnLoad = useRef(null);
  const vRdxHead = useSelector(
    (state) => state.SlicePickingHead.value.PickingHead
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const columns = [
    {
      field: "G_SrNo",
      headerName: "Sr No",
      width: 50,
    },
    {
      field: "G_BinCd",
      headerName: "Bin Code",
      width: 90,
      hide: true,
    },
    {
      field: "BinName",
      headerName: "Bin Name",
      width: 320,
    },
    {
      field: "G_ItmCd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 320,
    },
    {
      field: "G_CardID",
      headerName: "Card Id",
      width: 100,
      hide: true,
    },

    {
      field: "G_Qty",
      headerName: "Qty",
      width: 50,
    },
    {
      field: "G_Unit",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "G_BaseQty",
      headerName: "Base Qty",
      width: 100,
    },
  ];

  const [DetailGridData, setDetailGridData] = useState([]);
  const [UserGridData, setUserGridData] = useState([]);

  const sEnterKeyObj = {
    key: "Enter",
  };

  const [sOpenPickingModel, setOpenPickingModel] = useState(false);

  const fClosePickingModel = () => {
    setOpenPickingModel(false);
  };

  const fOpenPickingModel = () => {
    setOpenPickingModel(true);
  };

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {      
      let PrintURl =
        vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val +
        "WMS/PickingList?TrnTyp=" +
        xPrnTyp +
        "&VocTyp=" +
        vRdxHead.VocTyp +
        "&VocNo=" +
        vRdxHead.VocNo;
      console.log("PrintURl", PrintURl);
      setWebReportUrlModal(PrintURl);
      fWebReport();
    },
    [vRdxDBKernObj, vRdxHead.VocNo, vRdxHead.VocTyp]
  );
  const setValidation = () => {
    let iRes = true;

    if (
      vRdxHead.VocNo === "" ||
      vRdxHead.VocNo === null ||
      vRdxHead.VocNo === undefined
    ) {
      fAlertToast("FAILED", "VocNo should not be empty");
      iRes = false;
    }
    if (
      vRdxHead.VocTyp === "" ||
      vRdxHead.VocTyp === null ||
      vRdxHead.VocTyp === undefined
    ) {
      fAlertToast("FAILED", "VocTyp should not be empty");
      iRes = false;
    }
    if (DetailGridData.length === 0) {
      fAlertToast("FAILED", "Line item should not be empty");
      iRes = false;
    }

    return iRes;
  };

  const fPost = () => {
    if (setValidation()) {
      GetPickingPosting();
    }
  };

  //api call

  const GetPickingPosting = async () => {
    let vPickingPostingObj = {
      v_VocTyp: vRdxHead.VocTyp,
      v_VocNo: vRdxHead.VocNo,
      v_UserCd: vRdxuserInfo.UserID,
      v_IP: vRdxuserInfo.IP,
      v_Typ: vRdxHead.Type,
    };
    const vPickingPosting = await picking_PickingApprove_API(
      vPickingPostingObj
    );
    if (vPickingPosting.status === 200) {
      fAlertToast("SUCCESS", "Posted Successfully");
      dispatch(PickingHead_Status_Set({ Status: "POST" }));
    }
  };

  const fload_Grid = useCallback(async (xVocTyp, xVocNo) => {
    let vPickingLineItemsObj = {
      v_G_VocTyp: xVocTyp,
      v_G_VocNo: xVocNo,
    };

    const vPickingLineItems = await picking_PickingGetrow_API(
      vPickingLineItemsObj
    );
    if (vPickingLineItems.status === 200) {
      if (vPickingLineItems?.data?.ResultSet?.Items.length > 0) {
        let iResp = vPickingLineItems?.data?.ResultSet?.Items.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setDetailGridData(iResp);
      } else {
        setDetailGridData([]);
      }
      if (vPickingLineItems?.data?.ResultSet?.Users?.length > 0) {
        let iResp = vPickingLineItems?.data?.ResultSet?.Users.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setUserGridData(iResp);
      } else {
        setUserGridData([]);
      }
    }
  }, []);

  useEffect(() => {
    if (
      vRdxHead.VocTyp === "" ||
      vRdxHead.VocTyp === null ||
      vRdxHead.VocTyp === undefined ||
      vRdxHead.VocNo === "" ||
      vRdxHead.VocNo === null ||
      vRdxHead.VocNo === undefined
    ) {
      fAlertToast("FAILED", "VocNo and VocTyp should not be empty");
      return;
    } else {
      fload_Grid(vRdxHead.VocTyp, vRdxHead.VocNo);
    }
  }, [fload_Grid, vRdxHead.VocTyp, vRdxHead.VocNo]);

  useEffect(() => {
    BarcodeFocusOnLoad.current?.focus();
  }, []);

  const [sDetailGridColumn, setDetailGridColumn] = useState([]);

  useEffect(() => {
    GetGitterColumns(setDetailGridColumn, "WMPKLSTGETWB", columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid   ">
      <div className={vMediaQuery ? "" :"Breadcrumbs"}>
        <Picking_Breadcrumbs />
      </div>
      <div className="picking-detail">
        <Box sx={{ flexGrow: 1 }} className="mb-2">
          <Grid container spacing={1} columns={{ xs: 6, sm: 12, md: 12 }}>
            <Grid item xs={2} sm={"auto"} md={1}>
              <CmpButton
                xbtnName="Post"
                xOnClick={fPost}
                xVariant="contained"
                xSize="small"
                xDisabled={(vRdxHead?.Status).toUpperCase() === "POST"}
              />
            </Grid>
            <Grid item xs={2} sm={"auto"} md={1} className="text-center">
              <DropdownButton
                id="dropdown-basic-button"
                title="Print"
                variant="primary"
                size={vMediaQuery?"sm":"md"}
                disabled={false}
              >
                <Dropdown.Item
                  onClick={(e) => {
                    fPrint("WMPKLSTA");
                  }}
                >
                  Picking List
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => {
                    fPrint("WMPKLSTD");
                  }}
                >
                  Auto Picking List
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => {
                    fPrint("WMPKLSTG");
                  }}
                >
                  Picking Vs Picked
                </Dropdown.Item>
              </DropdownButton>
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              md={1}
              className=" btn-instant-picking-Detail"
            >
              <CmpButton
                xbtnName="Detail"
                xOnClick={fOpenPickingModel}
                xVariant="contained"
                xSize="small"
                xDisabled={false}
              />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            rowSpacing={{ xs: 0.9, sm: 0.9, md: 0.9 }}
            columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          >
            <Grid item xs={12} sm={12} md={4}  >
              <Grid
                container
                spacing={0.9}
                columns={{ xs: 12, sm: 12, md: 12 }}
                className={"align-items-center"}
              >
 
                <Grid item xs={12} sm={6} md={6}  >
                <CmpTextFieldV1
                    xLabelText="Doc.Name"
                    xValue={vRdxHead.VocTypName}
                    xType={"text"} // text/number/password
                    xName={"VocTyp"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
                 
                <Grid item xs={12} sm={6} md={6}  >
                  <CmpTextFieldV1
                    xLabelText="Doc.No"
                    xValue={vRdxHead.VocNo}
                    xType={"text"} // text/number/password
                    xName={"A_VocNo"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
 
                <Grid item xs={12} sm={6} md={6}  >
                  <CmpTextFieldV1
                    xLabelText="Doc.Date"
                    xValue={moment(vRdxHead.PostDate).format("MM/DD/YYYY")}
                    xType={"text"} // text/number/password
                    xName={"PostDate"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
             
                <Grid item xs={12} sm={6} md={6}  >
                 <CmpTextFieldV1
                    xLabelText="From.Date"
                    xValue={moment(vRdxHead.FromDate).format("MM/DD/YYYY")}
                    xType={"text"} // text/number/password
                    xName={"FromDate"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
 
                <Grid item xs={12} sm={6} md={6}  >
                  <CmpTextFieldV1
                    xLabelText="To.Date"
                    xValue={moment(vRdxHead.ToDate).format("MM/DD/YYYY")}
                    xType={"text"} // text/number/password
                    xName={"ToDate"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4}  >
              <Grid
                container
                spacing={0.9}
                columns={{ xs: 12, sm: 12, md: 12 }}
                className={"align-items-center"}
              >
                
                <Grid item xs={12} sm={6} md={6}  >
                <CmpTextFieldV1
                    xLabelText={"Transaction Type"}
                    xValue={vRdxHead.TransactionType}
                    xType={"text"} // text/number/password
                    xName={"TransactionType"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              
                <Grid item xs={12} sm={6} md={6}  >
               <CmpTextFieldV1
                xLabelText="Cluster"
                    xValue={vRdxHead.Cluster}
                    xType={"text"} // text/number/password
                    xName={"Cluster"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              
                <Grid item xs={12} sm={6} md={6}  >
                <CmpTextFieldV1
                xLabelText="Loading Bay"
                    xValue={vRdxHead.LoadingBay}
                    xType={"text"} // text/number/password
                    xName={"LoadingBay"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
               
                <Grid item xs={12} sm={6} md={6}  >
                 <CmpTextFieldV1
                xLabelText="Location"
                    xValue={vRdxHead.LocName}
                    xType={"text"} // text/number/password
                    xName={"LocName"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
               
                <Grid item xs={12} sm={6} md={6}  >
               <CmpTextFieldV1
                xLabelText="Type"
                    xValue={vRdxHead.Type}
                    xType={"text"} // text/number/password
                    xName={"Type"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4}   className={vMediaQuery? 'mt-1':""}>
              <Box
                style={{ height: vMediaQuery ? "50vh" : "16vh", width: "100%" }}
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={30}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  height={20}
                  getRowId={(row) => row.id}
                  rows={UserGridData}
                  columns={[
                    {
                      field: "User",
                      headerName: "User",
                      width: 200,
                    },
                  ]}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  experimentalFeatures={{ newEditingApi: false }}
                  hideFooter={UserGridData.length < 100}
                  // onRowClick={fGridRowData}
                  // components={{
                  //   Toolbar: GridToolbar,
                  // }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>

        <div className=" mt-3">
          <div className="xs-instant-picking-detail-grid">
            <Box sx={{ height: "50vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                getRowId={(row) => row.id}
                rows={DetailGridData}
                columns={sDetailGridColumn}
                // pageSize={5}
                // rowsPerPageOptions={[5]}
                hideFooter={DetailGridData.length < 100}
                // onRowClick={fGridRowData}
                components={{
                  Toolbar: GridToolbar,
                }}
              />
            </Box>
          </div>
        </div>
        <Box sx={{ flexGrow: 1 }} className="my-2">
          <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12 }}>
            <Grid item xs={12} sm={6} md={6} 
             className={vMediaQuery ? "text-center" : ""}
            >
              <CmpStatus
                xStatus={vRdxHead.Status}
                xStatusName={"PICKING STATUS = "}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              
              className={vMediaQuery ? "text-center" : "text-end"}
            >
              <CmpStatus
                xStatus={vRdxHead.DocStatus}
                xStatusName={"DOCUMENT STATUS = "}
              />
            </Grid>
          </Grid>
        </Box>
      </div>

      <Modal
        open={sOpenPickingModel}
        onClose={fClosePickingModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
           
          <GCTitleSticky title={'Grid'} onClose={fClosePickingModel} />
        
          <div className="py-2">
            <Box style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                height={20}
                getRowId={(row) => row.id}
                rows={DetailGridData}
                columns={sDetailGridColumn}
                // pageSize={5}
                // rowsPerPageOptions={[5]}
                experimentalFeatures={{ newEditingApi: false }}
                hideFooter={DetailGridData.length < 100}
                // onRowClick={fGridRowData}
                components={{
                  Toolbar: vMediaQuery?'':GridToolbar,
                }}
              />
            </Box>
          </div>
        </Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
